import { HeroProps } from "@/src/sections/hero/v1";

export const heroData_ar: HeroProps = {
  items: [
    {
      image: {
        src: "/assets/images/hero/Bone2.webp",
        alt: "hero 1",
      },
      title: "أهلا بكم في عالم أنتم مركزه",
      button: {
        label: "استكشف المزيد",
        href: "/",
      },
    },
    {
      image: {
        src: "/assets/images/hero/Bthree.webp",
        alt: "hero 1",
      },
      title: "تمكين مستقبلك الرقمي",
      button: {
        label: "استكشف المزيد",
        href: "/",
      },
    },
    {
      image: {
        src: "/assets/images/hero/Btwo.webp",
        alt: "hero 1",
      },
      title: "نركز على الابتكار والأمن السيبراني",
      button: {
        label: "استكشف المزيد",
        href: "/",
      },
    },
  ],
};
